import React from 'react';
import HeroSection from '../HeroSection';
import MainSection from '../MainSection';
import Footer from '../Footer';

function LandingPage() {
  return (
    <div>
      <HeroSection />
      <MainSection />
      <Footer />
    </div>
  );
}

export default LandingPage;
